const ALCHEMY_API_URL = process.env.NEXT_PUBLIC_ALCHEMY_API_URL || "";
const PROFESSIONS_CONTRACT = process.env.NEXT_PUBLIC_PROFESSIONS;

import { AbiItem } from "web3-utils";
import RaiderProfessions from "../../contracts/RaiderProfessions.json";

import { createAlchemyWeb3 } from "@alch/alchemy-web3";
const web3 = createAlchemyWeb3(ALCHEMY_API_URL);

// Professions Key:
// 1: Herbalism
// 2: Alchemy

const professionsContract = new web3.eth.Contract(
	RaiderProfessions.abi as AbiItem[],
	PROFESSIONS_CONTRACT
);

export const getAccount = async () => {
	if ((window as any).current_provider) {
		web3.setWriteProvider((window as any).current_provider)
		if ((window as any).current_provider.isMetaMask) {
			//metamask
			return (window as any).current_provider.selectedAddress
		} else {
			return (window as any).current_provider.accounts[0];
		}
	} 
};

export async function getRaiderExp(raider: number, profession: number) {
	try {
		const result = await professionsContract.methods
			.getRaiderExp(raider, profession)
			.call();
		return Number(result);
	} catch (err) {
		console.log(err);
	}
}
